import { render, staticRenderFns } from "./ProjectAlertModal.vue?vue&type=template&id=127eb23a"
import script from "./ProjectAlertModal.vue?vue&type=script&lang=js"
export * from "./ProjectAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports